/**
 * @file Whether one derived value's rendered sentence names a table, which is the
 * only reason a filler surface reads the `tableTypes` collection. Consumers: the
 * derived-field popover state and the per-form Derived values drawer, both of which
 * gate `useFormDeriveLabelResolvers`' subscription on it, so a form whose derives
 * are all field-to-field opens no listener. Pure.
 * Invariant: `tableId` is the discriminator the aggregate and set-valued sources
 * carry and the field and reference sources lack; narrow the algebraic arm with
 * `'operands' in entry` before touching `source`.
 */
import type { FormDeriveEntry } from '#types';

function formDeriveNamesATable(entry: FormDeriveEntry): boolean {
  return 'operands' in entry
    ? entry.operands.some((operand) => 'tableId' in operand.source)
    : 'tableId' in entry.source;
}

export { formDeriveNamesATable };
